import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTimePicker, FlexRow } from '@guryou/html-components';
import { dateIsAfter, dateIsBetween, timeIsAfter, timeIsBetween } from '@guryou/utils';
import { printInputDate } from '@guryou/utils/build/dateTimeUtils';

const OnboardingDateRange = ({
  startDateFieldName,
  startTimeFieldName,
  endDateFieldName,
  endTimeFieldName,
  startValue,
  endValue,
  inline,
  onChange,
  wrapperXs,
  wrapperMd,
  wrapperLg,
  wrapperMargin,
  wrapperJustifyContent = 'space-around',
  startLabel,
  endLabel,
  xs,
  min,
  max,
  margin = 'normal',
  disableStart,
  disableEnd,
  ...rest
}) => {
  const { t } = useTranslation();
  const [start, setStart] = useState(startValue);
  const [end, setEnd] = useState(endValue);

  const onStartChangeHandler = val => {
    setStart(val);
    onChange && onChange(val, end);
  };
  const onEndChangeHandler = val => {
    setEnd(val);
    onChange && onChange(start, val);
  };

  const handleStartFieldErrors = () => {
    if (startDateFieldName && start && end && dateIsAfter(printInputDate(start), printInputDate(end), true)) {
      return t('VALIDATIONS.endDateBeforeStartDate');
    }
    if (startTimeFieldName && !startDateFieldName && start && end && timeIsAfter(start, end)) {
      return t('VALIDATIONS.endTimeBeforeStartTime');
    }
    if (min && max && ((startTimeFieldName && !timeIsBetween(start, min, max)) || (startDateFieldName && !dateIsBetween(start, min, max)))) {
      return t('VALIDATIONS.breakDateNotBetween');
    }
    return null;
  };

  const handleEndFieldErrors = () => {
    if (min && max && ((startTimeFieldName && !timeIsBetween(end, min, max)) || (startDateFieldName && !dateIsBetween(end, min, max)))) {
      return t('VALIDATIONS.breakDateNotBetween');
    }
    return null;
  };

  const content = (
    <>
      <DateTimePicker
        margin={margin}
        xs={xs || (inline ? 6 : 12)}
        label={startLabel || t('GENERAL.from')}
        dateFieldName={startDateFieldName}
        timeFieldName={startTimeFieldName}
        value={start}
        onChange={onStartChangeHandler}
        errorMessage={handleStartFieldErrors()}
        disabled={disableStart}
        disableField={disableStart}
        {...rest}
      />
      <DateTimePicker
        margin={margin}
        xs={xs || (inline ? 6 : 12)}
        label={endLabel || t('GENERAL.to')}
        dateFieldName={endDateFieldName}
        timeFieldName={endTimeFieldName}
        value={end}
        onChange={onEndChangeHandler}
        errorMessage={handleEndFieldErrors()}
        disabled={disableEnd}
        disableField={disableEnd}
        {...rest}
      />
    </>
  );

  if (inline) {
    return (
      <FlexRow
        xs={wrapperXs}
        md={wrapperMd}
        lg={wrapperLg}
        margin={wrapperMargin && wrapperMargin}
        alignItems="baseline"
        justifyContent={wrapperJustifyContent}
      >
        {content}
      </FlexRow>
    );
  }

  return content;
};

export default OnboardingDateRange;
